howspace.components.itemPicker = (() => {
    'use strict';

    const popovers = new WeakMap();

    const updateLegacyCollapses = (itemPicker) => {
        if (itemPicker.find('.item').length <= 100) {
            return;
        }

        const optionSelector = itemPicker.hasClass('has-popover') ? '.item' : '.item:not(.selected)';
        let firstGroup = itemPicker.find('.item-group:has(.item.matched) button[aria-controls]')[0] || null;
        if (firstGroup === null) {
            firstGroup = itemPicker.find(`.item-group:has(${optionSelector}) button[aria-controls]`)[0] || null;
        }
        if (firstGroup) {
            howspace.components.collapse.expand(firstGroup, false);
        }

        itemPicker.find('.item-group button[aria-controls][aria-expanded="true"]').each(function () {
            if (this !== firstGroup) {
                howspace.components.collapse.collapse(this, false);
            }
        });
    };

    const updateCollapses = (itemPicker) => {
        if (itemPicker.data('collapse-opt-groups-by-default') !== true) {
            updateLegacyCollapses(itemPicker);
            return;
        }

        const searching = itemPicker.find('.item-groups').hasClass('searching');
        const optionSelector = itemPicker.hasClass('has-popover') ? '.item' : '.item:not(.selected)';

        itemPicker.find('.item-group button[aria-controls]').each(function () {
            const group = $(this).closest('.item-group');
            const shouldExpand = searching && group.find(`${optionSelector}.matched`).length > 0;

            if (shouldExpand && this.getAttribute('aria-expanded') !== 'true') {
                howspace.components.collapse.expand(this, false);
            } else if (!shouldExpand && this.getAttribute('aria-expanded') === 'true') {
                howspace.components.collapse.collapse(this, false);
            }
        });
    };

    const updateFilterButtons = (itemPicker) => {
        itemPicker.find('.filter-type-btn').each(function() {
            const filter = $(this);
            const type = filter.data('type');
            const count = itemPicker.find(`.item:not(.selected)[data-type="${type}"]`).length;
            if (count === 0) {
                filter.addClass('d-none').removeClass('btn-primary').addClass('btn-secondary').attr('aria-pressed', 'false');
            } else {
                filter.removeClass('d-none');
            }
        });
    };

    return {
        ITEM_ADDED: 'item-picker-item-added',
        ITEM_REMOVED: 'item-picker-item-removed',
        init: elem => {
            elem.findIncludingSelf('.howspace-item-picker:not(.howspace-item-picker-initialized)').each(function () {
                const itemPicker = $(this);
                itemPicker.addClass('howspace-item-picker-initialized');
                const isPopover = itemPicker.hasClass('has-popover');
                const optionSelector = isPopover ? '.item' : '.item:not(.selected)';

                const selectedItems = itemPicker.find('.selected-items .howspace-sortable-list-items');
                const searchInput = itemPicker.find('.howspace-form-search-input');
                const filterTypeButtons = itemPicker.find('.filter-type-btn');
                const filterTypeSelect = itemPicker.find('.filter-type-select');
                const itemGroups = itemPicker.find('.item-groups');
                const unselectedItems = itemGroups.find('.howspace-sortable-list');
                const statusMessage = itemPicker.find('[data-status-message]');

                const announce = (message) => {
                    // Toggle the text via empty string so repeated identical messages are re-announced.
                    statusMessage.text('');
                    requestAnimationFrame(() => statusMessage.text(message));
                };

                const search = (value, addedItem = false) => {
                    value = value.toLowerCase().trim();

                    const filterType = isPopover
                        ? howspace.components.searchableSelect.getValue(filterTypeSelect) || null
                        : itemPicker.find('.filter-type-btn.btn-primary').data('type') ?? null;

                    if (value.length > 0 || filterType) {
                        itemGroups.addClass('searching');

                        // match items by title and type
                        unselectedItems.find(optionSelector).each(function () {
                            const item = $(this);
                            // String casting due widget titles such as "1" get turned into ints by
                            // jQuery data(), which then crashes on the includes() below.
                            const title = String(item.data('title') || '');
                            const type = item.data('type');

                            if (title.includes(value) && (!filterType || filterType === type)) {
                                item.addClass('matched');
                            } else {
                                item.removeClass('matched');
                            }
                        });

                        // match groups by title
                        itemGroups.find(`.item-group:has(${optionSelector})`).each(function () {
                            const group = $(this);
                            const title = group.data('title');

                            if (title.includes(value)) {
                                if (filterType) {
                                    group.find(`${optionSelector}[data-type="${filterType}"]`).addClass('matched');
                                } else {
                                    group.find(optionSelector).addClass('matched');
                                }
                            }
                        });
                    } else {
                        itemGroups.removeClass('searching');
                        unselectedItems.find(optionSelector).removeClass('matched');
                    }

                    if (!addedItem) {
                        updateCollapses(itemPicker);
                        if (isPopover) {
                            itemGroups.scrollTop(0);
                        }
                    }
                };

                updateCollapses(itemPicker);

                const onAddItemCollapseExpanding = (e) => {
                    if (e.target !== e.currentTarget) {
                        // ignore events from item group cards
                        return;
                    }

                    if (!addItemPopover.length) {
                        searchInput[0].scrollIntoView({behavior: 'smooth', block: 'start'});
                    }

                    if (!addItemPopover.length && !howspace.isMobile()) {
                        real.input.focus(searchInput);
                    }

                    updateFilterButtons(itemPicker);
                };

                const onAddItemCollapseCollapsing = (e) => {
                    if (e.target !== e.currentTarget) {
                        // ignore events from item group cards
                        return;
                    }

                    // set aria-expanded attribute to false
                    itemPicker.find('.add-item-btn').attr('aria-expanded', false);
                };

                const onAddItemCollapseCollapsed = (e) => {
                    if (e && e.target !== e.currentTarget) {
                        // ignore events from item group cards
                        return;
                    }

                    // clear checkboxes
                    unselectedItems.find('.checkbox').each(function () {
                        this.checked = isPopover && this.closest('.item').classList.contains('selected');
                    });

                    // clear type filter
                    filterTypeButtons.removeClass('btn-primary').addClass('btn-secondary').attr('aria-pressed', 'false');
                    howspace.components.dropdown.close(filterTypeSelect);
                    howspace.components.searchableSelect.setValue(filterTypeSelect, '');

                    // clear search
                    searchInput.val(null).trigger('input');

                    if (!addItemPopover.length) {
                        itemPicker.find('.add-item-btn')[0]?.focus();
                    }
                };

                const addItemCollapse = itemPicker.find('.add-item-collapse');
                const addItemPopover = itemPicker.find('.add-item-popover');
                const addButton = itemPicker.find('.add-item-btn')[0];
                if (addItemPopover.length) {
                    popovers.set(this, howspace.popover.bind(addButton, addItemPopover, {
                        onClose: () => onAddItemCollapseCollapsed(),
                        getInitialFocus: () => howspace.isMobile()
                            ? filterTypeSelect.find('[data-toggle="dropdown"]')[0]
                                ?? addItemPopover.find('.close-collapse-btn')[0]
                            : searchInput[0],
                        getReturnFocus: () => addButton.disabled
                            ? selectedItems.find('.delete-item-btn')[0]
                            : addButton
                    }));
                }
                const closePicker = () => {
                    if (addItemPopover.length) {
                        popovers.get(itemPicker[0]).close();
                    } else {
                        howspace.components.collapse.close(addItemCollapse);
                    }
                };

                addItemCollapse.on(howspace.components.collapse.EXPANDING, onAddItemCollapseExpanding);
                addItemCollapse.on(howspace.components.collapse.COLLAPSING, onAddItemCollapseCollapsing);
                addItemCollapse.on(howspace.components.collapse.COLLAPSED, onAddItemCollapseCollapsed);

                itemPicker.find('.close-collapse-btn').on('click', () => {
                    closePicker();
                });

                itemPicker.on('input', '.value', (e) => {
                    const input = $(e.currentTarget);
                    const value = input.val();

                    // find the corresponding checkbox
                    const checkbox = input.closest('.item').find('.checkbox');

                    // update the value of the checkbox
                    const checkboxValue = JSON.parse(checkbox.val());
                    checkboxValue.value = value;
                    checkbox.val(JSON.stringify(checkboxValue));
                });

                const removeItem = (item, {announceChange = true} = {}) => {
                    // show item in unselected items
                    const unselectedItem = unselectedItems.find(`.item[data-id="${item.data('id')}"]`);
                    unselectedItem.removeClass('selected');

                    // clear checkbox
                    unselectedItem.find('.checkbox').prop('checked', false).prop('disabled', false);

                    // remove item from selected items
                    const finishRemoval = () => {
                        const focusTarget = item[0]?.contains(document.activeElement)
                            ? item.nextAll('.item').first().find('.delete-item-btn')[0]
                                ?? item.prevAll('.item').first().find('.delete-item-btn')[0]
                                ?? addButton
                            : null;
                        if (announceChange) {
                            announce(item.data('title'));
                        }
                        item.remove();

                        // hide sortable list in case it's empty
                        itemPicker.find('.selected-items:not(:has(.item))').addClass('d-none');

                        if (focusTarget?.isConnected && !focusTarget.disabled) {
                            focusTarget.focus({preventScroll: true});
                        }

                        // trigger ITEM_REMOVED event
                        howspace.dispatchEvent(itemPicker, howspace.components.itemPicker.ITEM_REMOVED, {
                            item: {
                                id: item.data('id'),
                                type: item.data('type')
                            }
                        });
                    };
                    if (isPopover) {
                        finishRemoval();
                    } else {
                        item.velocity('slideUp', 'fast', finishRemoval);
                    }

                    // enable Add item button
                    itemPicker.find('.add-item-btn').prop('disabled', false);

                    if (!isPopover) {
                        updateFilterButtons(itemPicker);
                    }

                    // search
                    search(searchInput.val(), isPopover);
                };

                itemPicker.on('click', '.delete-item-btn', e => removeItem($(e.currentTarget).closest('.item')));

                searchInput.on('input', () => search(searchInput.val()));
                filterTypeSelect.on(howspace.components.searchableSelect.CHANGE, () => search(searchInput.val()));

                filterTypeButtons.on('click', e => {
                    const btn = $(e.currentTarget);

                    if (btn.hasClass('btn-secondary')) {
                        filterTypeButtons.removeClass('btn-primary').addClass('btn-secondary').attr('aria-pressed', 'false');
                        btn.removeClass('btn-secondary').addClass('btn-primary').attr('aria-pressed', 'true');
                    } else {
                        btn.removeClass('btn-primary').addClass('btn-secondary').attr('aria-pressed', 'false');
                    }

                    search(searchInput.val());
                });

                const addItem = (item, {announceChange = true} = {}) => {
                    const checkbox = item.find('.checkbox');
                    itemPicker.find('.selected-items').removeClass('d-none');
                    item.addClass('selected');
                    checkbox.prop('checked', true);
                    const clone = item.clone();
                    selectedItems.append(clone);
                    if (!isPopover) {
                        clone.velocity('slideDown', {duration: 'fast', display: 'flex'});
                    }
                    checkbox.prop('checked', isPopover);
                    if (!isPopover) {
                        updateFilterButtons(itemPicker);
                    }
                    search(searchInput.val(), true);

                    if (!isPopover && unselectedItems.find('.item:not(.selected)').length === 0) {
                        itemPicker.find('.add-item-btn').prop('disabled', true);
                        closePicker();
                    }

                    if (announceChange) {
                        announce(item.data('title'));
                    }
                    howspace.dispatchEvent(itemPicker, howspace.components.itemPicker.ITEM_ADDED, {
                        item: {id: item.data('id'), type: item.data('type')}
                    });
                };

                itemPicker.find('.save-selection-btn').on('click', () => {
                    const changes = unselectedItems.find('.checkbox').toArray().filter(input =>
                        input.checked !== input.closest('.item').classList.contains('selected')
                    ).map(input => ({item: $(input).closest('.item'), checked: input.checked}));

                    // Close before changing the selected list so its growth cannot move an open picker.
                    closePicker();
                    changes.forEach(({item, checked}) => {
                        if (checked) {
                            addItem(item, {announceChange: false});
                        } else {
                            removeItem(selectedItems.find(`.item[data-id="${item.data('id')}"]`), {announceChange: false});
                        }
                    });
                    if (changes.length > 0) {
                        const added = changes.filter(({checked}) => checked).length;
                        announce(howspace.translate('common_item_picker_selection_updated', {
                            added,
                            removed: changes.length - added
                        }));
                    }
                });

                if (!isPopover) {
                    unselectedItems.find('.checkbox').on('change', e => {
                        const checkbox = $(e.currentTarget);
                        const item = checkbox.closest('.item');
                        if (!checkbox.prop('checked') || item.hasClass('selected')) {
                            return;
                        }
                        // Disable while the inline picker delays addition so repeated clicks cannot queue duplicates.
                        checkbox.prop('disabled', true);
                        setTimeout(() => addItem(item), 350);
                    });
                }
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-item-picker.howspace-item-picker-initialized').each(function () {
                const itemPicker = $(this);
                popovers.get(this)?.destroy();
                popovers.delete(this);
                itemPicker.removeClass('howspace-item-picker-initialized');
            });
        },
    };
})();
